<div class="headerText">Work Orders</div>
<div>
  <div class="filterBar dayView">
    <p-floatlabel variant="on">
      <input pInputText id="work-order-label" [(ngModel)]="searchTerm" autocomplete="off" (ngModelChange)="searchInput.next($event)" fluid style="margin: 10px 0 0px 5px;"/>
      <label for="work-order-label"><i class="pi pi-search"></i> Search</label>
    </p-floatlabel>

    <div class="filterBoxContainer dayView">
      <div class="filterBox dayView" style="margin: -5px 0 0px 5px;">
        <p-button type="text" (click)="opServiceType.toggle($event)" severity="secondary" >Service Type <i class="pi pi-caret-down"></i></p-button>
        <p-popover #opServiceType appendTo="body">
          Show Work Orders with Service Type:<br/>
          <p-multiselect autofocusFilter placeholder="Choose" placeholder="Choose" [options]="serviceTypes" [(ngModel)]="advancedFilters.services" [panelStyle]="{minWidth:'12em'}" (ngModelChange)="filterBarInput.next($event)"></p-multiselect >
        </p-popover>
      </div>
      <div class="filterBox dayView" style="margin: -5px 0 0px 5px;">
        <p-button type="text" (click)="opWOStatus.toggle($event)" severity="secondary">WO Status <i class="pi pi-caret-down"></i></p-button>
        <p-popover #opWOStatus appendTo="body">
          Show Work Orders with WO Status:<br/>
          <p-multiselect autofocusFilter placeholder="Choose"  [options]="woStatuses" [(ngModel)]="advancedFilters.completionStatuses" [panelStyle]="{minWidth:'12em'}" (ngModelChange)="filterBarInput.next($event)"></p-multiselect >
        </p-popover>
      </div>
      <div class="filterBox dayView" style="margin: -5px 0 0px 5px;">
        <p-button type="text" (click)="opPaymentStatus.toggle($event)" severity="secondary">Payment Status <i class="pi pi-caret-down"></i></p-button>
        <p-popover #opPaymentStatus appendTo="body">
          Show Work Orders with Payment Status:<br/>
          <p-multiselect autofocusFilter placeholder="Choose"  [options]="paymentStatuses" [(ngModel)]="advancedFilters.paymentStatuses" [panelStyle]="{minWidth:'12em'}" (ngModelChange)="filterBarInput.next($event)"></p-multiselect >
        </p-popover>
      </div>
      <div class="filterBox dayView" style="margin: -5px 0 0px 5px;">
        <p-button type="text" (click)="opRM.toggle($event)" severity="secondary">RM <i class="pi pi-caret-down"></i></p-button>
        <p-popover #opRM appendTo="body">
          Show Work Orders with RM:<br/>
          <p-multiselect autofocusFilter placeholder="Choose"  [options]="rms" [(ngModel)]="advancedFilters.rMs" [panelStyle]="{minWidth:'12em'}" (ngModelChange)="filterBarInput.next($event)"></p-multiselect >
        </p-popover>
      </div>
      <div style="float: right; margin: -5px 0 0px 5px;">
        <p-button severity="secondary" label="Refresh" (click)="filterFromBar()"></p-button>
      </div>
    </div>
  </div>
  <div class="clear:both;"></div>
</div>

<p-table showGridlines stripedRows responsiveLayout="stack"
  class="no-pad-table-header"
  [columns]="cols"
  [value]="allWorkOrders"
  [paginator]="true"
  [rows]="rows"
  [lazy]="true"
  (onLazyLoad)="loadRequestLazy($event)"
  [totalRecords]="totalRecords"
  [loading]="isLoading"
  [sortField]="'DateCompleted'"
  [sortOrder]="-1"
  >
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [style.width]="col.width">
          @if (col.header == 'Amount Due') {
            <span pTooltip="Amount due is Work Order total minus cash/checks collected">{{col.header}}</span>
          }
          @if (col.header != 'Amount Due') {
            <span>{{col.header}}</span>
          }
          @if (col.header != '' && col.field) {
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-workOrder let-columns="columns" let-rowIndex="rowIndex">
    <tr>
      <td>
        <span class="p-column-title">{{columns[0].header}}</span>
        <span class="regular-link" (click)="navigateToWorkOrder(workOrder)">
          {{workOrder.number}}
        </span>
      </td>
      <td>
        <span class="p-column-title">{{columns[1].header}}</span>
        <span class="regular-link" (click)="navigateToCustomer(workOrder)">{{workOrder.customerName}}</span>
      </td>
      <td><span class="p-column-title">{{columns[2].header}}</span>{{workOrder.phoneNumber | phoneNumber}}</td>
      <td><span class="p-column-title">{{columns[3].header}}</span>{{workOrder.serviceType}}</td>
      <td>
        <span class="p-column-title">{{columns[4].header}}</span>
        {{workOrder.wOStatus}}
      </td>
      <td>
        <span class="p-column-title">{{columns[5].header}}</span>
        {{workOrder.dateCompleted}}
        @if (workOrder.wOStatus == 'Partially Complete' || workOrder.showAsPartiallyComplete) {
          <span>
            <i class="pi pi-question-circle" pTooltip="This is the most recent completed date of the tasks on the WO." style="vertical-align: middle;"></i>
          </span>
        }
      </td>
      <td>
        <span class="p-column-title">{{columns[6].header}}</span>
        <span [ngClass]="workOrder.paymentStatus == 'Paid' ? 'paid' : 'unpaid' ">
          {{workOrder.paymentStatus ? workOrder.paymentStatus : 'Unpaid' }}
        </span>
      </td>
      <td><span class="p-column-title">{{columns[7].header}}</span>{{workOrder.preferredPayment}}</td>
      <td><span class="p-column-title">{{columns[8].header}}</span>{{workOrder.cardOnFile}}</td>
      <td>
        <span class="p-column-title">{{columns[9].header}}</span>
        @if (workOrder.amountDue != undefined) {
          <span>
            {{workOrder.amountDue | currency: 'USD' : 'symbol'}}
            @if (workOrder.wOStatus == 'Partially Complete' || workOrder.showAsPartiallyComplete) {
              <span>
                <i class="pi pi-question-circle" pTooltip="This is the total due for the unpaid invoices - does not include tasks that are not complete" style="vertical-align: middle;"></i>
              </span>
            }
          </span>
        }
        @if (workOrder.amountDue == undefined) {
          <span style="margin-left:8px; text-align: center;">
            <i class="pi pi-spin pi-spinner" style="font-size: 14px"></i>
          </span>
        }
      </td>
      <td>
        <span class="p-column-title">{{columns[10].header}}</span>
        <div style="text-align: center;">
          <app-payment-options-td
            [workOrder]="workOrder"
            (invoicesEvent)="openInvoiceForRow($event)"
            (addCashEvent)="addCashForRow($event)"
            (chargeInvoiceEvent)="chargeInvoiceForRow($event)"
            (refundEvent)="refundInvoiceForRow($event)"
            (finalizeEvent)="finalize($event)">
          </app-payment-options-td>
        </div>
      </td>
      <td class="showLineBreaks">
        <span class="p-column-title">{{columns[11].header}}</span>
        {{workOrder.latestNote}}
        @if (workOrder.latestNote) {
          <br/>
        }
        <span class="regular-link" (click)="addNoteForRow(workOrder)">
          [new note]
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- Adding Customer Comment -->
@if (showAddNoteDialog) {
  <div class="scrollableDialog">
    <p-dialog header="Internal Notes" [(visible)]="showAddNoteDialog" [modal]="true" [resizable]="true" [baseZIndex]="10000"
      [maximizable]="true" [style]="{'width': '1560px'}" [focusOnShow]="false" (onHide)="closedDialog()" [closable]="false" [blockScroll]="true" [positionTop]="0" [minY]="70" >
      <p-header style="float:right;">
        <a class="ui-dialog-titlebar-icon ui-dialog-titlebar-close ui-corner-all}" tabindex="0" role="button" (click)="closedDialog()" (keydown.enter)="closedDialog()" (mousedown)="closedDialog()">
          <span><i class="pi pi-times"></i></span>
        </a>
      </p-header>
      <app-customer-comments
        [customerIdInput]="addNoteWorkOrderRow.customerId"
        [claimNames]="claimNames"
        [defaultWONumber]="addNoteWorkOrderRow.number"
        [defaultCategory]="'Payment'"
      ></app-customer-comments>
    </p-dialog>
  </div>
}

@if (showInvoicesDialog) {
  <app-invoices [showDialog]="showInvoicesDialog" [workOrder]="showInvoicesRow" [userId]="userId" (close)="closedDialog($event)"></app-invoices>
}

<!-- Adding Cash Collected -->
@if (showAddCashDialog) {
  <app-add-cash [showDialog]="showAddCashDialog" [workOrder]="addCashWorkOrderRow" [userId]="userId" (close)="closedDialog($event)" (charge)="chargeInvoice($event, true)"></app-add-cash>
}

<!-- Showing customer card data and creating/charging invoice for WO -->
@if (showChargeCardDialog) {
  <app-charge-card [showDialog]="showChargeCardDialog" [workOrder]="chargeCardWorkOrderRow" (close)="closedDialog($event)" (charge)="chargeInvoice($event)"></app-charge-card>
}

@if (showRefundDialog) {
  <app-refund-invoice [showDialog]="showRefundDialog" [workOrder]="refundWorkOrderRow" (close)="closedDialog($event)"></app-refund-invoice>
}

<p-dialog [(visible)]="showFinalizeLoading" [modal]="true" [blockScroll]="false" (onHide)="closedDialog(false)" [style]="{width: '480px'}">
  <app-loading-swirly [isLoading]="showFinalizeLoading"></app-loading-swirly> Please wait while the system processes.
</p-dialog>